import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { saveVentilator } from '../../procedures/ventilator/store/ventilator.actions'
import { QuickActionsConstants } from '../store/quickActions.constants'

export function* setVentilatorQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addVentilatorToTimeline } = quickActionsObject
  if (addVentilatorToTimeline) {
    yield put(saveVentilator())
  }
}

export function* setVentilatorQuickActionTimeLineRowSaga() {
  yield takeLatest([QuickActionsConstants.SET_ADD_VENTILATOR_TO_TIMELINE], setVentilatorQuickActionTimeLineRow)
}
